module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.data) ? _c('div', {
    staticClass: "dialog-wrap"
  }, [_c('b-dialog', {
    attrs: {
      "mask": _vm.dialogData.mask,
      "mshow": _vm.dialogData.show,
      "maskOpacity": _vm.dialogData.maskOpacity,
      "maskBackground": _vm.dialogData.maskBackground,
      "maskClass": _vm.maskClass
    }
  }, [_c('div', {
    staticClass: "upgrade-pop-box",
    class: _vm.renderCls
  }, [_c('div', {
    staticClass: "block"
  }), _vm._v(" "), _c('div', {
    staticClass: "level-icon"
  }, [_c('beast-image', {
    attrs: {
      "src": _vm.data.levelIcon
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "pop-title"
  }, [_vm._v(_vm._s(_vm.data.title))]), _vm._v(" "), _c('div', {
    staticClass: "pop-desc"
  }, [_vm._v(_vm._s(_vm.data.desc))]), _vm._v(" "), _c('div', {
    staticClass: "pop-items"
  }, _vm._l((_vm.data.vipBenefits), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "pop-item"
    }, [_c('div', {
      staticClass: "pop-icon"
    }, [_c('beast-image', {
      attrs: {
        "src": item.icon
      }
    })], 1), _vm._v(" "), _c('div', {
      staticClass: "pop-name"
    }, [_vm._v(_vm._s(item.name))])])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "pop-btn",
    class: _vm.renderCls,
    on: {
      "click": _vm.benefitAction
    }
  }, [_vm._v("查看更多专属特权")]), _vm._v(" "), _c('div', {
    staticClass: "upgrade-close-box",
    on: {
      "click": _vm.upgradePopClose
    }
  }, [_c('div', {
    staticClass: "upgrade-close"
  })])])])], 1) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7adb166c"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./static/app-index-V4/components/upgrade-pop.vue
// module id = 999
// module chunks = 13